<template>
  <div>
    <div
      class="position-absolute display-4"
      style=" top:-256px; left: -630px; transform: rotate(-90deg);"
    >
      LOAD GROUP
    </div>
    <div
      class="col-12 d-flex justify-content-center"
      v-html="removeDO"
    />
    <div
      v-if="info.summary.body.length > 0"
      class="bg-fade-primary-dark-8 p-1 h2"
    >
      <span>{{ info.summary.heading }}</span>
      <span class="text-secondary">
        {{ info.summary.body }}
      </span>
    </div>
    <div
      v-else
      class="bg-fade-primary-dark-8 p-1 h2"
    >
      <span>
        No loads are being controlled
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OffPeakStatus',
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  computed: {
    removeDO() {
      return this.info.table.replace(/DO/g, ' ');
    },
  },
};
</script>
